<template>
  <div>
    <van-sticky>
      <van-search v-model="reqData.productValue" show-action placeholder="请输入商品名称/款号/条码" @search="onSearch">
        <template #action>
          <van-icon @click="popupShow" name="filter-o" size="1.2rem" />
        </template>
      </van-search>
      <van-dropdown-menu>
        <van-dropdown-item v-model="reqData.sortType" :options="rankOptions" @change="sortChange" />
      </van-dropdown-menu>
      <van-tabs class="title" v-model="tab" ref="tabRef" title-active-color="#1989fa" @change="onTabChange">
        <van-tab name="day" title="本日" />
        <van-tab name="week" title="本周" />
        <van-tab name="month" title="本月" />
        <van-tab name="custom">
          <template #title>
            <span @click="calendarShow"><van-icon name="notes-o" />自定义</span>
          </template>
        </van-tab>
      </van-tabs>
    </van-sticky>
    <!--商品明细-->
    <van-list v-model="nextLoading" :finished="pageFinish" finished-text="已经到底了" @load="onPageLoad">
      <div v-for="(item, index) in pdtRankList" :key="index" style="border-bottom: 1px solid #969799;">
        <van-row class="sku-bg">
          <van-col span="6">
            <van-image width="6rem" height="6rem" fit="contain" :src="imgUrl + item.productName"
              @click="showImg(item.productName)" />
          </van-col>
          <van-col span="12">
            <div class="pdt-value">{{ item.productCode }}</div>
            <div class="sku-info">{{ item.productName }}/{{ item.barCode }}/{{ item.color }}</div>
          </van-col>
          <van-col span="6">
            <div class="pdt-stock">库存：{{ item.totalInventory | AmtFormat }}</div>
            <div class="sku-expected">预计可售{{ item.estimatedSellingDays }}天</div>
          </van-col>
        </van-row>
        <van-grid :column-num="4">
          <van-grid-item>
            <div class="tot-content">{{ item.totalRevenue | AmtFormat }}</div>
            <div class="tot-title">销售收入</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.salesRatio }}</div>
            <div class="tot-title">收入占比</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.quantity | AmtFormat }}</div>
            <div class="tot-title">销售数量</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.quantityRatio }}</div>
            <div class="tot-title">数量占比</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.avgSellingPrice }}</div>
            <div class="tot-title">平均均价</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.standardPrice }}</div>
            <div class="tot-title">标准价</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ item.averageDiscount }}</div>
            <div class="tot-title">平均折扣</div>
          </van-grid-item>
          <van-grid-item @click="toPdtTrend(item)">
            <van-icon size="20" color="#379bff" name="play-circle-o" />
            <div style="color: #379bff; font-size: 12px;">查看销售趋势</div>
          </van-grid-item>
        </van-grid>
      </div>
    </van-list>
    <!--日期过滤-->
    <van-calendar v-model="dateShow" class="calendar" :min-date="minDate" :max-date="maxDate" type="range"
      @confirm="onDateConfirm" />
    <!--过滤-->
    <van-popup v-model="filterShow" round position="bottom" :style="{ height: '80%' }">
      <van-row style="height: 90%;">
        <!--左边筛选条件-->
        <van-col span="6">
          <van-sidebar v-model="activeFilter" @change="onFilterChange">
            <van-sidebar-item title="年份" />
            <van-sidebar-item title="季节" />
            <van-sidebar-item title="性别" />
            <van-sidebar-item title="大类" />
          </van-sidebar>
        </van-col>
        <!--右边筛选明细-->
        <van-col span="17" offset="1" style="overflow-y: auto;">
          <!--属性筛选-->
          <van-checkbox-group v-model="checkboxList" @change="onResultChange">
            <van-row style="padding-top: 0.5rem; width: 100%;">
              <van-col v-for="item in childList" :key="item.key" span="12">
                <van-checkbox :name="item.key" class="childItem">
                  <template #icon="props">
                    <van-button size="normal" plain hairline block v-if="props.checked" color="#379bff">
                      {{ item.value }}
                    </van-button>
                    <van-button size="normal" plain hairline block v-else>{{ item.value }}</van-button>
                  </template>
                </van-checkbox>
              </van-col>
            </van-row>
          </van-checkbox-group>
        </van-col>
      </van-row>
      <!--按钮-->
      <van-row type="flex" justify="space-around" style="margin-top: 0.5rem;">
        <van-col span="11"><van-button color="#1989fa" block round @click="onConfirm">确定</van-button></van-col>
        <van-col span="11"><van-button type="warning" block round @click="onClear">重置</van-button></van-col>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import { reqDimensions, reqProductSales } from "@/api/board";
import { ImagePreview } from 'vant';

export default {
  name: "pdtRank",

  data() {
    return {
      imgUrl: Glob.IMG_URL,

      filterShow: false,
      activeFilter: 0,

      tab: 'day',
      dateStr: '本日',

      dateShow: false,
      minDate: null,
      maxDate: null,

      //下一页
      nextLoading: false,
      pageFinish: true,

      pdtRankList: [],
      //排序类型
      rankOptions: [
        { text: '按金额排序', value: 'AMT_DESC' },
        { text: '按数量排序', value: 'QTY_DESC' },
      ],

      //属性明细控件
      searchFilter: null,
      filterTemp: {},
      checkboxList: [],
      filterResult: { yearDim: [], seasonDim: [], genderDim: [], categoryDim: [] },
      childList: [],

      //请求参数
      reqData: {
        startDate: null,
        endDate: null,
        productValue: null,
        sortType: 'AMT_DESC',
        filterdata: { yearDim: [], seasonDim: [], genderDim: [], categoryDim: [] },
        pageNum: 1,
        pageSize: 10,
      },

    }
  },

  computed: {

  },

  beforeRouteEnter(to, from, next) {
    if (from.path == "/") {
      //刷新跳转回主页
      next((vm) => {
        //vm.$router.push({ name: "login" });
      });
    } else if (from.path == "/index") {
      next((vm) => {
        //获取跳转入参
        vm.reqData.startDate = vm.$route.params.startDate;
        vm.reqData.endDate = vm.$route.params.endDate;
        vm.reqData.filterdata = { yearDim: [], seasonDim: [], genderDim: [], categoryDim: [] };
        vm.tab = vm.$route.params.tab;
        vm.dateStr = vm.$route.params.dateStr;
        vm.checkboxList = [];
        vm.filterResult = { yearDim: [], seasonDim: [], genderDim: [], categoryDim: [] };
        //获取属性过滤
        reqDimensions().then((res) => {
          vm.filterTemp = res;
          //默认显示年份
          vm.activeFilter = 0;
          vm.childList = vm.filterTemp.DIM2;
        });
        //获取数据
        vm.pdtRankList = [];
        vm.getProductSales(1);
      });
    } else {
      next();
    }
  },

  created() {
    //初始化数据
    let nowDate = new Date();
    this.dateShow = false;
    this.filterShow = false;
    this.minDate = new Date(this.$moment(nowDate).subtract(2, 'year').startOf('year').format());
    this.maxDate = nowDate;
    this.reqData.sortType = 'AMT_DESC';
  },

  mounted() {

  },

  methods: {
    //切换tab
    onTabChange(name) {
      //获取默认日期  this.$moment('20230102').format()
      let nowDate = new Date();
      if (name == 'day') {
        this.reqData.startDate = this.$moment(nowDate).format('YYYYMMDD');
        this.reqData.endDate = this.$moment(nowDate).format('YYYYMMDD');
        this.dateStr = '本日';
      } else if (name == 'week') {
        this.reqData.startDate = this.$moment(nowDate).startOf("isoWeek").format('YYYYMMDD');
        this.reqData.endDate = this.$moment(nowDate).endOf("isoWeek").format('YYYYMMDD');
        this.dateStr = '本周';
      } else if (name == 'month') {
        this.reqData.startDate = this.$moment(nowDate).startOf("month").format('YYYYMMDD');
        this.reqData.endDate = this.$moment(nowDate).endOf("month").format('YYYYMMDD');
        this.dateStr = '本月';
      }
      //获取数据
      this.pdtRankList = [];
      this.getProductSales(1);
    },
    //切换排序
    sortChange() {
      //获取数据
      this.pdtRankList = [];
      this.getProductSales(1);
    },
    //弹出过滤界面
    popupShow() {
      this.filterShow = true;
    },
    //切换筛选条件
    onFilterChange() {
      //更新右边
      switch (this.activeFilter) {
        case 0:
          this.childList = this.filterTemp.DIM2;
          //更新选择的过滤明细
          if (this.filterResult.yearDim.length == 0) {
            this.checkboxList = [];
          } else {
            this.checkboxList = this.filterResult.yearDim;
          }
          break;
        case 1:
          this.childList = this.filterTemp.DIM3;
          //更新选择的过滤明细
          if (this.filterResult.seasonDim.length == 0) {
            this.checkboxList = [];
          } else {
            this.checkboxList = this.filterResult.seasonDim;
          }
          break;
        case 2:
          this.childList = this.filterTemp.DIM4;
          //更新选择的过滤明细
          if (this.filterResult.genderDim.length == 0) {
            this.checkboxList = [];
          } else {
            this.checkboxList = this.filterResult.genderDim;
          }
          break;
        case 3:
          this.childList = this.filterTemp.DIM5;
          //更新选择的过滤明细
          if (this.filterResult.categoryDim.length == 0) {
            this.checkboxList = [];
          } else {
            this.checkboxList = this.filterResult.categoryDim;
          }
          break;
        default:
          console.log("属性错误");
      }
    },
    //选择筛选明细
    onResultChange(items) {
      //根据当前选择的属性处理
      switch (this.activeFilter) {
        case 0:
          this.filterResult.yearDim = items;
          break;
        case 1:
          this.filterResult.seasonDim = items;
          break;
        case 2:
          this.filterResult.genderDim = items;
          break;
        case 3:
          this.filterResult.categoryDim = items;
          break;
        default:
          console.log("属性错误");
      }
    },
    //过滤选择确认
    onConfirm() {
      this.reqData.filterdata = this.filterResult;
      this.filterShow = false;
      //获取数据
      this.pdtRankList = [];
      this.getProductSales(1);
    },
    //重置筛选
    onClear() {
      this.checkboxList = [];
      this.filterResult = [];
    },
    //搜索
    onSearch() {
      //获取数据
      this.pdtRankList = [];
      this.getProductSales(1);
    },
    //日期选择
    calendarShow() {
      this.dateShow = true;
    },
    //选择日期
    onDateConfirm(date) {
      this.dateShow = false;
      this.reqData.startDate = this.$moment(date[0]).format('YYYYMMDD');
      this.reqData.endDate = this.$moment(date[1]).format('YYYYMMDD');
      this.dateStr = this.$moment(date[0]).format('M.D') + "-" + this.$moment(date[1]).format('M.D');
      //获取数据
      this.pdtRankList = [];
      this.getProductSales(1);
    },
    //跳转商品销售趋势
    toPdtTrend(pdtInfo) {
      this.$router.push({
        name: "pdtRankItem", params: {
          startDate: this.reqData.startDate, endDate: this.reqData.endDate,
          pdtInfo: pdtInfo,
        }
      });
    },
    //下一页
    onPageLoad() {
      this.nextLoading = true;
      this.getProductSales(this.reqData.pageNum + 1);
    },
    //获取商品排行数据
    getProductSales(pageNum) {
      //发出请求
      this.reqData.pageNum = pageNum;
      reqProductSales(this.reqData).then((res) => {
        if (pageNum == 1) {
          this.pdtRankList = res.data;
        } else {
          res.data.forEach((item) => {
            this.pdtRankList.push(item);
          });
        }
        //判断是否加载完毕
        if (this.pdtRankList.length >= res.totalCount) {
          this.pageFinish = true;
        } else {
          this.pageFinish = false;
        }
        this.nextLoading = false;
      });
    },
    //展示图片
    showImg(pdtName) {
      ImagePreview([this.imgUrl + pdtName]);
    },
  },
}
</script>

<style scoped lang="less">
/deep/ .title .van-tabs__line {
  background-color: #1989FA;
}

/deep/ .van-calendar__day--start {
  background-color: #379bff;
}

/deep/ .van-calendar__day--middle {
  background-color: #c8dcff;
}

/deep/ .van-calendar__day--end {
  background-color: #379bff;
}

/deep/ .van-calendar__day--middle {
  color: #379bff;
}

/deep/ .calendar .van-button--danger {
  color: #fff;
  background-color: #379bff;
  border: 1px solid #379bff;
}

/deep/ .van-sidebar-item--select::before {
  background-color: #379bff;
}

/deep/ .van-dropdown-menu__title--active {
  color: #379bff;
}

/deep/ .van-dropdown-item__option--active {
  color: #379bff;
}

/deep/ .van-dropdown-item__option--active .van-dropdown-item__icon {
  color: #379bff;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

/deep/ .childItem .van-checkbox__icon {
  height: 3rem;
  width: 7.5rem;
  font-size: 2.2rem;
}

.pdt-value {
  font-size: 0.9rem;
  padding-left: 0.5rem;
  padding-top: 0.5rem;
}

.sku-info {
  font-size: 0.6rem;
  padding-left: 0.5rem;
  padding-top: 2.5rem;
  color: #969799;
}

.pdt-stock {
  font-size: 0.8rem;
  color: #379bff;
  border-color: #379bff;
  padding: 0.4rem 0.6rem;
  background-color: #fff;
  border: 1px solid #379bff;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: 2rem;
  text-align: center;
  cursor: pointer;
  transition: opacity 0.2s;
  -webkit-appearance: none;
  border-radius: 5vw;
  margin-top: 0.5rem;
}

.sku-expected {
  font-size: 0.6rem;
  padding-left: 0.5rem;
  padding-top: 1.6rem;
  color: #969799;
}

.sku-bg {
  background-color: #fff;
}

.tot-title {
  font-size: 0.7rem;
  color: #969799;
}

.tot-content {
  font-size: 1rem;
  font-family: "Arial";
}

/deep/ .van-dropdown-menu__title {
  color: #646566;
}

/deep/ .childItem .van-button--hairline {
  border-width: 1px;
}
</style>


// WEBPACK FOOTER //
// src/view/board/pdtRank.vue